<nav class="nav cardtabs flex-column">
  <div class="back-and-menu-link">
    <a
        *ngIf="backLink"
        [routerLink]="[backLink.path]"
        class="nav-link back-link"
    >{{backLink.title}}</a>
    <button
        class="collapse-menu-link"
        (click)="toggleCollapse()"
    ><i class="fas fa-bars"></i></button>
  </div>

  <!-- main links -->
  <div class="flex-column" [ngClass]="collapsed ? 'collapsed' : ''">
    <ng-container *ngFor="let menuItem of tabitems">
      <a
          *ngIf="!menuItem.subLink"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ queryParams: 'exact', matrixParams: 'exact', paths: 'exact', fragment: 'exact' }"
          [routerLink]="menuItem.pathParams ? [menuItem.path, menuItem.pathParams] : [menuItem.path]"
          [queryParams]="menuItem.queryParams"
          class="nav-link {{menuItem.class}}"
      >{{menuItem.title}}
        <span
            *ngIf="menuItem.badge"
            class="badge badge-pill"
            [ngClass]="[menuItem.badge.className]"
            [ngbTooltip]="menuItem.badge.tooltip ? menuItem.badge.tooltip : null"
            placement="bottom"
        >{{ menuItem.badge.text }}</span>
      </a>
      <a
          *ngIf="menuItem.subLink"
          class="nav-link active sub-link {{menuItem.class}}"
      >{{menuItem.title}}
      </a>
    </ng-container>
  </div>
</nav>
